import type { Dealer } from './api.js';

export function filterDealers(items: Dealer[], cityId: string): Dealer[] {
  if (!cityId) return [];
  return items.filter((item) => String(item.city_id) === cityId)
    .sort((a, b) => a.region.localeCompare(b.region, 'ru') || a.organization.localeCompare(b.organization, 'ru'));
}

export function dealerCities(items: Dealer[]): { id: string; name: string; count: number }[] {
  const groups = new Map<string, { id: string; name: string; count: number }>();
  for (const item of items) {
    const id = String(item.city_id);
    const group = groups.get(id) ?? { id, name: item.region, count: 0 };
    group.count++;
    groups.set(id, group);
  }
  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name, 'ru'));
}

export function dealerMapUrl(dealer: Dealer): string | null {
  if (!dealer.address.trim()) return null;
  const url = new URL('https://yandex.ru/maps/');
  url.searchParams.set('text', `${dealer.city}, ${dealer.address}`);
  return url.toString();
}

export function dealerSiteUrl(value: string): string | null {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
}

/** Берём первый номер, не склеивая его с подписью офиса/добавочным. */
export function dealerPhoneHref(value: string): string | null {
  const number = value.match(/\+?\d[\d\s().-]{5,}\d/)?.[0].replace(/[^\d+]/g, '');
  return number ? `tel:${number}` : null;
}
